import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/senior-friendly.css';
import { SeniorAppRouterProvider } from './providers/seniorRoute';
import { AuthProvider } from './providers/auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <SeniorAppRouterProvider />
  </AuthProvider>
);
